import api from "@/api.js";

export default {
  state: {
    stock: [],
    stockLoading: false,
    lastStockFetch: null
  },
  mutations: {
    setStock(state, payload) {
      state.stock = payload;
    },
    setStockLoading(state, loading) {
      state.stockLoading = loading;
    },
    setLastStockFetch(state, now) {
      state.lastStockFetch = now;
    }
  },
  actions: {
    async loadStock({ commit, state }, forced) {
      let now = new Date().getTime();
      if (
        state.lastStockFetch == null ||
        now - state.lastStockFetch > 60 * 1000 ||
        state.stock.length == 0 ||
        forced
      ) {
        commit("setStockLoading", true);
        let stock = await api.get("stock");
        commit("setLastStockFetch", new Date().getTime());
        // localStorage.setItem("stock", JSON.stringify(stock.data));
        commit("setStock", stock.data);
        commit("setStockLoading", false);
      }
    },
    async stockUploadImage({ commit }, payload) {
      let returnData;
      await api
        .post("stock/uploadImage", payload)
        .then(result => {
          returnData = {
            Result: "Success",
            Response: result
          };
          return returnData;
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
          return returnData;
        });
      return returnData;
    }
  },
  getters: {
    stock(state) {
      return state.stock;
    },
    stockLoading(state) {
      return state.stockLoading;
    }
  }
};
